import React from 'react';
import { useSelector } from 'react-redux';
import SplitterLayout from 'react-splitter-layout';
import Map from 'components/Panels/Map/Map';
import sh from 'components/shared.module.css';
import PaginationHeader from './PaginationHeader';
import PaginationBody from './PaginationBody';


const Pagination = ({ tabId, mapIsAvailiable, view='' }) => {
  const { tab } = useSelector(state => ({
    tab: state.tabs[tabId]
  }));
  const { showJustTheMap } = tab.selections;
  const { geo } = tab.dataset;

  /* in this specific view we have extra 25px of height and I can't
     figure out why, so I custom handle this here and in the parrent */
  const mapPlacement = (view === 'leftPanelIsNotOpen && rightPanelIsOpen')
    ? { bottom: 42 }
    : { bottom: 42 + 25 };
  const paginationBodyHeight = (view === 'leftPanelIsNotOpen && rightPanelIsOpen')
    ? { height: '100%' }
    : { height: 'calc(100% - 25px)' };

  if (!mapIsAvailiable) {
    return (
      <div className={sh.sidePanelCont}>
        <PaginationHeader itemFirst={1} itemLast={39} itemNum={2123} bucketNum={2} {...{ tabId }} />
        <div className={sh.normalize} style={paginationBodyHeight}>
          <PaginationBody {...{ tabId, mapIsAvailiable }} />
        </div>
      </div>
    );
  }

  return (
    <div className={sh.sidePanelCont}>
      <PaginationHeader itemFirst={1} itemLast={39} itemNum={2123} bucketNum={2} {...{ tabId, geo, showJustTheMap }} />
      <div className={sh.normalize}>
        <SplitterLayout vertical style={{ overflowY: 'hidden' }}>
          {(!showJustTheMap) && <PaginationBody {...{ tabId, mapIsAvailiable }} />}
          <Map style={mapPlacement} className={sh.mapCont} />
        </SplitterLayout>
      </div>
    </div>
  );

};

export default Pagination;
